import React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { 
    Typography, 
    Button, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogTitle,
    Card,
    CardContent,
    CardActionArea,
    CardMedia
} from "@mui/material";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import {getInventory} from "../../utilityFunctions/WarehouseUtil";
import { PuffLoader } from "react-spinners";
import { css } from "@emotion/react";
import Colors from "../../components/ui/Colors";
import { useHistory} from "react-router-dom";

const cssLoader = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

export default function Inventory(props) {

    const {loginUser} = props;

    const history = useHistory();

    const [loading, setLoading] = React.useState(false);
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [selectedProduct, setSelectedProduct] = React.useState(null);

    React.useEffect(() => {
        setLoading(true);
        renderInventory();
    }, []);

    const initialValues = async () => {
        const products = await getInventory(loginUser.jwtToken);

        return products;
    };

    const [inventory, setInventory] = React.useState("");

    const renderInventory = async() => {
        setLoading(true);
        const productsInventory = await initialValues();
        setLoading(false);

        if(!productsInventory){
            return;
        }

        productsInventory.sort((a, b) => {
            const nameA = a.description.toLowerCase();
            const nameB = b.description.toLowerCase();
            
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });

        setInventory(
            <List sx={{width: "100%", marginTop: {xs: "3rem", sm: "2rem", md: "2rm"}}}>
                {productsInventory.map((product) => {
                    return(
                        <ListItem key={generateRandomKey()} disablePadding divider sx={{marginBottom: "1.5rem"}}>
                            <ListItemButton key={generateRandomKey()} onClick={() => handleProductClick(product)}>
                                <Grid key={generateRandomKey()}  container spacing={1}>
                                    <Grid key={generateRandomKey()} item xs={4} sm={4} md={4} sx={{display: "flex", justifyContent: "center"}}>
                                        <Typography key={generateRandomKey()} variant="body2">{product.barCode}</Typography>
                                    </Grid>
                                    <Grid key={generateRandomKey()} item xs={4} sm={4} md={4} sx={{display: "flex", justifyContent: "center"}}>
                                        <Typography key={generateRandomKey()} variant="body2">{product.description}</Typography>
                                    </Grid>
                                    <Grid key={generateRandomKey()} item xs={4} sm={4} md={4} sx={{display: "flex", justifyContent: "center"}}>
                                        <Typography key={generateRandomKey()} variant="body2">{new Intl.NumberFormat('es-CO').format(product.totalInventory)}</Typography>
                                    </Grid>
                                </Grid>
                            </ListItemButton>
                        </ListItem>
                    )
                })}
            </List>
        );
    };

    const handleProductClick = (product) => {
        if(!product){
            return;
        }
        
        // Create a product object that matches the format expected by the detail views
        const productForDetail = {
            barCode: product.barCode,
            description: product.description,
            itemNumber: product.itemNumber,
            totalInventory: product.totalInventory
        };
        
        setSelectedProduct(productForDetail);
        setDialogOpen(true);
    };
    
    const handleDialogClose = () => {
        setDialogOpen(false);
    };
    
    const navigateToDailyInventory = () => {
        if(!selectedProduct){
            return;
        }

        console.log(selectedProduct);
        
        history.push({
            pathname: "/warehouse/daily-inventory",
            state: {
                product: selectedProduct,
            }
        });
        setDialogOpen(false);
    };
    
    const navigateToInventoryByCode = () => {
        if(!selectedProduct){
            return;
        }
        
        history.push({
            pathname: "/warehouse/inventory-by-code",
            state: {
                product: selectedProduct,
            }
        });
        setDialogOpen(false);
    };

    const generateRandomKey = () => {
        const randomString = Math.random().toString(36).slice(2);
        const timestamp = Date.now().toString(36);
        return randomString + '_' + timestamp;
    };

    return (
        <Box sx={{display: "flex", justifyContent: "center", width: "100%", height: "100%"}}>
            <Box
                sx={{
                    display: "flex",
                    // flex: 1,
                    justifyContent: "center",
                    alignItems: {xs: "start", sm: "center"},
                    width: "90%",
                    height: "100%",
                    textAlign: "center",
                    overflowY: "scroll",
                }}
            >
            {loading ? <PuffLoader size={100} color={Colors.secondary} css={cssLoader} /> :
            <Grid container>
                {/* <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        onClick={() => history.push("/warehouse/inventory-by-code")}
                    >
                        Ver Inventario por Lote
                    </Button>
                </Grid> */}
                <Grid item xs={12} sm={12} md={12}>
                    <Grid container sx={{marginTop: "1rem"}}>
                        <Grid key={generateRandomKey()} item xs={4} sm={4} md={4} sx={{display: "flex", justifyContent: "center"}}>
                            <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Código de Barras</Typography>
                        </Grid>
                        <Grid key={generateRandomKey()} item xs={4} sm={4} md={4} sx={{display: "flex", justifyContent: "center"}}>
                            <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Producto</Typography>
                        </Grid>
                        <Grid key={generateRandomKey()} item xs={4} sm={4} md={4} sx={{display: "flex", justifyContent: "center"}}>
                            <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Cantidad</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    {inventory}
                </Grid>
            </Grid>
            }
            
            {/* Selection Dialog */}
            <Dialog 
                open={dialogOpen} 
                onClose={handleDialogClose}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    {selectedProduct && `Seleccione una opción para ${selectedProduct.description}`}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={3} sx={{ mt: 1 }}>
                        <Grid item xs={12} md={6}>
                            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                <CardActionArea onClick={navigateToDailyInventory} sx={{ height: '100%', p: 2 }}>
                                    <CardContent sx={{ textAlign: 'center' }}>
                                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold', mb: 2 }}>
                                            Inventario Diario
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary">
                                            Ver el inventario diario detallado del producto seleccionado.
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                <CardActionArea onClick={navigateToInventoryByCode} sx={{ height: '100%', p: 2 }}>
                                    <CardContent sx={{ textAlign: 'center' }}>
                                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold', mb: 2 }}>
                                            Inventario por Lote
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary">
                                            Ver el inventario agrupado por lotes del producto seleccionado.
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="primary">
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>
            </Box>
        </Box>
    )
}
